import {
  getClientsService, 
  registerClientService, 
  editClientService, 
  deleteClientService
} from '../service/ClientsService';

export const getClients = async () => {
  try {
    const response = await getClientsService();
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const registerClient = async (registerClientRequest) => {
  try {
    const response = await registerClientService(registerClientRequest);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const editClientFromDatabase = async (id, clientData) => {
  try {
    const response = await editClientService(id, clientData);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteClientFromDatabase = async (id) => {
  try {
    const response = await deleteClientService(id);
    return response.data;
  } catch (err) {
    throw err;
  }
};

